import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom
import Calender from './CalenderPage';

import VideoPlayer from './Videoplayer';
import line from './asset/line.png';
import Fav from './asset/fav.png';
import './VideoPlayer.module.css';
import styles from './VideoPlayer.module.css';

const Page2 = () => {
    const [show, setShow] = useState(false);
    const [show2, setShow2] = useState(false);
    const [showV, setShowV] = useState(true);
    const [videoEnd, setVideoEnd] = useState(false);
    const navigate = useNavigate(); // Initialize navigate function

    useEffect(() => {
        setTimeout(() => {
            setShow(true);
        }, 5000); // Show the button after 5 seconds
    }, []);

    const formRef = useRef(null);

    const HndVideoEnd = () => {
        setVideoEnd(true);
    };

    const sbtHnd = (e) => {
        e.preventDefault();

        const formData = new FormData(formRef.current);
        const formObj = {};

        formData.forEach((value, key) => {
            formObj[key] = value;
        });

        const selectElements = formRef.current.querySelectorAll('select');
        selectElements.forEach((select) => {
            const name = select.name;
            const value = select.value;
            formObj[name] = value;
        });

        console.log(formObj);
    };

    const applyHnd = () => {
        setShow2(true);
        setShowV(false);
        setShow(false);
        navigate('/calender');
    };

    return (
        <div className="bg-black pt-1 px-4 sm:px-6 md:px-10">
            {/* Fav Image Section */}
            <div className="flex justify-center py-2 mb-4 sm:mb-4 md:mb-1">
                <img
                    src={Fav}
                    alt="Fav"
                    className="max-w-xs sm:max-w-sm md:max-w-md"
                />
            </div>

            {/* Schedule Text Section */}
            <p
                className="text-center py-1 pt-1 text-2xl sm:text-3xl md:text-4xl font-semibold text-gold1 md:mb-1 mb-4 sm:mb-4"
                style={{ color: '#DBB76A' }}
            >
                Schedule Your Call & Step Up Towards Trading Journey
            </p>

            <br></br>

            {/* <img className="mx-auto block -mt-10" src={line} alt="line" style={{ marginTop: '-65px' }} /> */}

            {/* Video Player Section */}
            {showV && (
                <div className="mt-1"> {/* Added margin-top to space out from the top */}
                    <VideoPlayer
                        HndVideoEnd={HndVideoEnd}
                        style={{ height: '40px' }} // Adjust the height as needed
                    />
                </div>
            )}

            {/* Apply Button     show && videoEnd &&*/}
            { show && videoEnd &&(
                <button
                    onClick={applyHnd}
                    className="mx-auto md:mb-0 block w-8/9 md:w-3/5 h-16 md:h-20 rounded-lg bg-gradient-to-l text-xl from-gold2 to-gold1 text-black px-4 py-2 text-center"
                >
                    Apply Here
                </button>
            )}
            <br></br>

            <div className={styles.stepBox}>
                <span className={styles.stepNumber}></span>
                <p className={styles.stepText} style={{ color: '#DBB76A' }}>
                    Learn the use of our unique strategies drafted as per each different
                    trading style and requirements.
                </p>
            </div>
            <br></br>
            <br></br>

            <p className="text-center text-white text-lg sm:text-xl md:text-xl font-semibold -mt-5 mb-4 bg-gradient-to-r from-gold1 to-yellow-350 p-4 rounded-xl shadow-lg transform hover:scale-105 transition duration-300 ease-in-out max-w-lg mx-auto">
                Betterment Trading Session with SKTA
            </p>

            <div className="h-8 bg-black "></div>

            {/* Conditional Calendar */}
            
            {/* {show2 && <Calender />} */}

            {/* Footer Section */}
            {/* <div className="text-center mt-8 sm:mt-12">
                <p className="text-white text-sm sm:text-base md:text-lg">
                    Powered by SKTA. Your journey to success starts here.
                </p>
            </div> */}
        </div>
    );
};

export default Page2;
